import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import JsonLd, { zebraPageMeta, zebraSchema } from 'components/common/schema'
import Template from 'components/LP/LP202407/Zebra'

const ZEBRA: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <HeadMeta {...zebraPageMeta} />
      <JsonLd data={zebraSchema} />
      <Template />
    </>
  )
}

export default ZEBRA
